import React, { useState, useEffect } from "react"
import { connect } from "react-redux"
import { Box } from "@infotech/uikit-grid"
import { selectAllStatus } from "src/engine/modules/status/selectors"
import pick from "lodash/pick"
import FieldSet from "@infotech/uikit-fieldset"
import Switch from "@infotech/uikit-switch"
import GlobalEscapeHandle from "src/components/GlobalEscapeHandle"
import { AddIcon, CloseIcon } from "@infotech/uikit-icons"
import { MiniButton } from "@infotech/uikit-button"
import Select from "@infotech/uikit-select"
import { CircleIcon } from "@infotech/uikit-extra-icons"
import { createEventStatus, useEventStatus, updateEventStatus } from "./helper"
import styles from "./styles.css"

const StatusesList = ({
  eventTypeId,
  resourceTypeList: { data: resourceData },
  statusModelPermission,
  refreshList,
  formData: { id },
  toggleForm,
  allStatus: {
    data: allStatusData,
    status: { pending: statusSelectPending },
  },
  triggerCreateStatus,
  closeModal,
}) => {
  const {
    formData,
    formData: { data, pending },
    changeFormData,
  } = useEventStatus({ id })
  const headerText = id ? `Добавление статуса` : `Редактирование статуса`
  const statusOptions = allStatusData.map(item => ({
    value: item.id,
    label: item.name,
    icon: CircleIcon,
    color: item.color,
    code: item.code,
  }))
  const resourceOptions = resourceData.map(item => ({
    value: item.id,
    label: item.name,
  }))
  const isDisabled = !statusModelPermission || !id || (pending && id)

  const [changeCount, setChangeCount] = useState(null)

  useEffect(() => {
    if (data.id && changeCount) {
      updateEventStatus({
        id: data.id,
        data: pick(data, [
          `statusId`,
          `eventTypeId`,
          `initial`,
          `restrictions`,
        ]),
        changeData: changeCount,
        setChangeCount,
        allFormData: formData,
        changeFormData,
        refreshList,
      })
    }
  }, [data])

  return (
    <Box loose className={styles.ModalWrapper}>
      <Box loose className={styles.ModalHeader} p="2md" flex row>
        <Box loose>{headerText}</Box>
        <Box loose className={styles.CloseIcon} onClick={closeModal}>
          <CloseIcon color="#627d98" />
        </Box>
      </Box>
      <Box loose pt="3md" pl="2md" flex column>
        <Box loose flex row>
          <Box loose className={styles.StatusHeader}>
            Статус
          </Box>
          <Box loose pl="2md" pt="2px">
            <MiniButton
              icon={AddIcon}
              disabled={!statusModelPermission}
              onClick={() => {
                toggleForm({ show: false, id: null })
                triggerCreateStatus(`new`)
              }}
            />
          </Box>
        </Box>
        <Box loose className={styles.Caption} pt="1md">
          При небходимости можно создать статус отсутствующий в списке
        </Box>
        <Box loose pt="2md" w="212px">
          <Select
            options={statusOptions}
            hideSelectedOptions
            disabled={statusSelectPending || !statusModelPermission}
            placeholder="Выберите статус"
            value={data.statusId}
            onChange={({
              target: {
                value: { value },
              },
            }) => {
              if (!id) {
                setChangeCount({
                  changeField: `status`,
                  oldValue: data.statusId,
                })
                createEventStatus({
                  eventTypeId,
                  id: value,
                  changeData: changeCount,
                  changeFormData,
                  toggleForm,
                  refreshList,
                })
              } else {
                setChangeCount({
                  changeField: `status`,
                  oldValue: data.statusId,
                })
                changeFormData({
                  ...formData,
                  data: { ...data, statusId: value },
                })
              }
            }}
          />
        </Box>
        <Box loose pt="2md">
          <Switch
            checked={data.initial}
            onChange={value => {
              setChangeCount({ changeField: `initial`, oldValue: data.initial })
              changeFormData({
                ...formData,
                data: { ...data, initial: value },
              })
            }}
            disabled={isDisabled}
            label="Начальный статус"
          />
        </Box>
        <Box loose pt="3md" className={styles.RestrictionsHeader}>
          Ограничения
        </Box>
        <Box loose pt="2md">
          <Switch
            disabled={isDisabled}
            label="Запрещено удалять событие"
            checked={data.restrictions.delete}
            onChange={value => {
              setChangeCount({
                changeField: `delete`,
                oldValue: data.restrictions.delete,
                restrictions: true,
              })
              changeFormData({
                ...formData,
                data: {
                  ...data,
                  restrictions: { ...data.restrictions, delete: value },
                },
              })
            }}
          />
        </Box>
        <Box loose pt="1md">
          <Switch
            disabled={isDisabled}
            label="Запрещено редактировать план события"
            checked={data.restrictions.plan}
            onChange={value => {
              setChangeCount({
                changeField: `plan`,
                oldValue: data.restrictions.plan,
                restrictions: true,
              })
              changeFormData({
                ...formData,
                data: {
                  ...data,
                  restrictions: { ...data.restrictions, plan: value },
                },
              })
            }}
          />
        </Box>
        <Box loose pt="2md">
          <Switch
            disabled={isDisabled}
            label="Запрещено редактировать название события"
            checked={data.restrictions.name}
            onChange={value => {
              setChangeCount({
                changeField: `name`,
                oldValue: data.restrictions.name,
                restrictions: true,
              })
              changeFormData({
                ...formData,
                data: {
                  ...data,
                  restrictions: { ...data.restrictions, name: value },
                },
              })
            }}
          />
        </Box>
        <Box loose pt="1md">
          <Switch
            disabled={isDisabled}
            label="Запрещено редактировать описание события"
            checked={data.restrictions.description}
            onChange={value => {
              setChangeCount({
                changeField: `description`,
                oldValue: data.restrictions.description,
                restrictions: true,
              })
              changeFormData({
                ...formData,
                data: {
                  ...data,
                  restrictions: { ...data.restrictions, description: value },
                },
              })
            }}
          />
        </Box>
        <Box loose pt="2md">
          <Switch
            disabled={isDisabled}
            label="Запрещено менять дату начала события"
            checked={data.restrictions.startDateTime}
            onChange={value => {
              setChangeCount({
                changeField: `startDateTime`,
                oldValue: data.restrictions.startDateTime,
                restrictions: true,
              })
              changeFormData({
                ...formData,
                data: {
                  ...data,
                  restrictions: { ...data.restrictions, startDateTime: value },
                },
              })
            }}
          />
        </Box>
        <Box loose pt="1md">
          <Switch
            disabled={isDisabled}
            label="Запрещено менять дату конца события"
            checked={data.restrictions.endDateTime}
            onChange={value => {
              setChangeCount({
                changeField: `endDateTime`,
                oldValue: data.restrictions.endDateTime,
                restrictions: true,
              })
              changeFormData({
                ...formData,
                data: {
                  ...data,
                  restrictions: { ...data.restrictions, endDateTime: value },
                },
              })
            }}
          />
        </Box>
        <Box loose pt="2md">
          <Switch
            disabled={isDisabled}
            label="Запрещено редактировать список ресуров события"
            checked={data.restrictions.resources}
            onChange={value => {
              setChangeCount({
                changeField: `resources`,
                oldValue: data.restrictions.resources,
                restrictions: true,
              })
              changeFormData({
                ...formData,
                data: {
                  ...data,
                  restrictions: {
                    ...data.restrictions,
                    resources: value,
                    restrictedResourceTypes: [],
                  },
                },
              })
            }}
          />
        </Box>
        <Box loose pt="2md" pr="2md">
          <FieldSet caption="Тип ресурса">
            <Select
              options={resourceOptions}
              hideSelectedOptions
              placeholder="Выберите тип ресурса"
              isMulti
              disabled={isDisabled || !data.restrictions.resources}
              value={data.restrictions.restrictedResourceTypes}
              onChange={({ target: { value } }) => {
                setChangeCount({
                  changeField: `restrictions.restrictedResourceTypes`,
                  oldValue: data.restrictions.restrictedResourceTypes,
                })
                changeFormData({
                  ...formData,
                  data: {
                    ...data,
                    restrictions: {
                      ...data.restrictions,
                      restrictedResourceTypes: value
                        ? value.map(item => item.value)
                        : [],
                    },
                  },
                })
              }}
            />
          </FieldSet>
        </Box>
      </Box>
      <GlobalEscapeHandle onEscapePress={closeModal} />
    </Box>
  )
}

export default connect(
  state => ({
    allStatus: selectAllStatus(state),
  }),
  null,
)(StatusesList)
